var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_upload",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M4.406,1.342A5.53,5.53,0,0,1,8,0a5.136,5.136,0,0,1,5.166,4.579A3.256,3.256,0,0,1,16,7.773,3.271,3.271,0,0,1,12.687,11H10a.5.5,0,0,1,0-1h2.688A2.271,2.271,0,0,0,15,7.773a2.271,2.271,0,0,0-2.313-2.228h-.5v-.5A4.116,4.116,0,0,0,8,1,4.53,4.53,0,0,0,5.059,2.1,2.956,2.956,0,0,0,3.906,4.155V4.6l-.445.049A2.719,2.719,0,0,0,1,7.318,2.732,2.732,0,0,0,3.781,10H6a.5.5,0,0,1,0,1H3.781A3.733,3.733,0,0,1,0,7.318,3.707,3.707,0,0,1,2.942,3.725,4.206,4.206,0,0,1,4.406,1.342Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M7.646,4.146a.5.5,0,0,1,.708,0l3,3a.5.5,0,1,1-.708.708L8.5,5.707V14.5a.5.5,0,0,1-1,0V5.707L5.354,7.854a.5.5,0,0,1-.708-.708Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.4565f5fe5655292c307fc01eb8572a6f.svg";
export { ForwardRef as ReactComponent };